<template>
    <x-data-table
        class="no-row-hover"
        :headers="headers"
        :items="subscriptionAgreements"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No subscription agreement</p>
        </template>

        <template v-slot:items="props">
            <td>{{ props.item.created_at | formatDate }}</td>
            <td>{{ props.item.updated_at | formatDate }}</td>
            <td>{{ props.item.created_by.name }}</td>
            <td>
                <x-btn
                    @click="editSubscriptionAgreement(props.item.id)"
                    color="tertiary"
                >
                    <x-icon>edit</x-icon>
                </x-btn>

            </td>
            <td>
                <x-btn
                    @click="download(props.item.id)"
                    outline
                    small
                >
                    Download
                </x-btn>
            </td>
        </template>
    </x-data-table>
</template>

<script>
    import rules from '~/mixins/rules';

    export default {
        name: "SubscriptionAgreementsTable",
        mixins: [rules],
        components: {
        },
        data: () => ({
            status: 'idle',
            dialog: {},
            headers: [
                {
                    text: 'Date created',
                    value: 'created_at'
                },
                {
                    text: 'Date last modified',
                    value: 'updated_at'
                },
                {
                    text: 'User',
                    value: ''
                },
                {
                    text: 'Edit',
                    value: ''
                },
                {
                    text: 'Download',
                    value: ''
                },
            ],
        }),
        props: {
            declaration: {
                type: Object,
                default: []
            }
        },
        computed: {
            subscriptionAgreements() {
                return this.declaration.subscription_agreements;
            },
            idle() {
                return this.status === 'idle';
            },
        },
        created() {
        },
        methods: {
            editSubscriptionAgreement(subAgreementId) {
                this.$router.push({path: `/agent/risk/${this.$route.params.id}/subscription-agreements/${subAgreementId}`});
            },
            async download(subAgreementId) {
                const fileUrl = (await axios.get(this.$root.api(`broker/subscription-agreements/${subAgreementId}/download`))).data.url;

                window.location.href = fileUrl;
            },
        },
        beforeDestroy() {
            //this.$eventBus.$off('action-review-amendment');
        }
    }
</script>
